// feature/bot-litisoft — sprint90 Phase 3. Admin cockpit · Historial de corridas.
// Past runs (done/cancelled/failed) + per-run detail (the número each case got,
// per-item errors). Admin-only (route + sidebar gated).
import React, { useEffect, useState } from "react";
import { bot } from "../../api/endpoints";
import Spinner from "../../components/Spinner";
import Empty from "../../components/Empty";

const fmt = (d) => (d ? new Date(d).toLocaleString("es-CO") : "—");

export default function BotLitisoftHistorial() {
  const [runs, setRuns] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    bot.runs().then((r) => setRuns(r.data.runs)).catch(() => setRuns([]));
  }, []);
  useEffect(() => {
    if (openId == null) { setDetail(null); return; }
    bot.runDetail(openId).then((r) => setDetail(r.data)).catch(() => setDetail(null));
  }, [openId]);

  const past = (runs || []).filter((r) => ["done", "cancelled", "failed"].includes(r.status));
  return (
    <div className="col" style={{ gap: 16 }}>
      <div className="muted">
        Las corridas que ya terminamos. Abre cualquiera para ver, caso por caso, el número LITISOFT
        que recibió y cualquier error que haya quedado registrado.
      </div>
      <div className="card" style={{ padding: 0 }}>
        {runs == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !past.length ? (
          <Empty title="Sin corridas pasadas" />
        ) : (
          <table>
            <thead><tr><th>#</th><th>Tipo</th><th>Estado</th><th>Ítems</th><th>Dry-run</th><th>Creada</th><th>Finalizada</th><th>Por</th></tr></thead>
            <tbody>
              {past.map((r) => (
                <tr key={r.id} onClick={() => setOpenId(openId === r.id ? null : r.id)} style={{ cursor: "pointer" }}>
                  <td><strong>#{r.id}</strong></td>
                  <td>{r.kind}</td>
                  <td>{r.status}</td>
                  <td>{r.completed_items}/{r.total_items}</td>
                  <td>{r.dry_run ? "Sí" : "No"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{fmt(r.created_at)}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{fmt(r.finished_at)}</td>
                  <td>{r.requested_by_name || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {openId != null && detail && (
        <div className="card" style={{ padding: 0 }}>
          <div style={{ padding: "10px 16px", fontWeight: 600 }}>Corrida #{openId} — resultados</div>
          {!detail.items?.length ? (
            <Empty title="Sin ítems" />
          ) : (
            <table>
              <thead><tr><th>Caso</th><th>Radicado</th><th>Estado</th><th>Número LITISOFT</th><th>Error</th></tr></thead>
              <tbody>
                {detail.items.map((it) => (
                  <tr key={it.id}>
                    <td>{it.case_number || "—"}</td>
                    <td style={{ fontFamily: "monospace", fontSize: 12 }}>{it.radicado}</td>
                    <td>{it.item_status}</td>
                    <td>{it.litisoft_numero || "—"}</td>
                    <td className="muted" style={{ fontSize: 12, maxWidth: 280, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={it.error_detail || ""}>{it.error_detail || ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
